import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
  Container,
  Typography,
  Box,
  Button,
  CircularProgress,
  Alert,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { fetchCourse } from '../store/thunks/coursesThunks';
import { generateQuizForCourse } from '../store/thunks/quizThunks';
import QuizPreview from '../components/quizzes/QuizPreview';
import { fetchQuestionsByCourseId } from '../services/firestore/questionService';
import { hasAttemptedQuiz } from '../services/quizAttemptService';

const StandaloneQuizPage: React.FC = () => {
  const { courseId } = useParams<{ courseId: string }>();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { selectedCourse, loading: courseLoading } = useAppSelector((state) => state.courses);
  const { loading: quizLoading } = useAppSelector((state) => state.quiz);
  const { isAuthenticated } = useAppSelector((state) => state.auth);
  const [showPreview, setShowPreview] = useState(true);
  const [questionCount, setQuestionCount] = useState(10);
  const [hasAttempted, setHasAttempted] = useState(false);

  useEffect(() => {
    if (courseId) {
      dispatch(fetchCourse(courseId));
      // Fetch question count
      fetchQuestionsByCourseId(courseId)
        .then((questions) => {
          setQuestionCount(questions.length);
        })
        .catch(() => {
          setQuestionCount(10); // Default
        });
      
      // Check if free user has already attempted
      if (!isAuthenticated) {
        setHasAttempted(hasAttemptedQuiz(courseId));
      }
    }
  }, [courseId, dispatch, isAuthenticated]);

  const handleStartQuiz = () => {
    if (courseId && (!hasAttempted || isAuthenticated)) {
      setShowPreview(false);
      dispatch(generateQuizForCourse({ courseId, isAuthenticated })).then(() => {
        navigate(`/courses/${courseId}/quiz`);
      });
    }
  };

  if (courseLoading || quizLoading) {
    return (
      <Container maxWidth="lg" sx={{ py: 8, textAlign: 'center' }}>
        <CircularProgress />
      </Container>
    );
  }

  if (!selectedCourse) {
    return (
      <Container maxWidth="lg" sx={{ py: 8 }}>
        <Alert severity="error">Course not found</Alert>
        <Button startIcon={<ArrowBackIcon />} onClick={() => navigate('/quizzes')} sx={{ mt: 2 }}>
          Back to Quizzes
        </Button>
      </Container>
    );
  }

  return (
    <>
      <QuizPreview
        open={showPreview}
        onClose={() => navigate('/quizzes')}
        onStart={handleStartQuiz}
        course={selectedCourse}
        questionCount={questionCount}
        isAuthenticated={isAuthenticated}
        hasAttempted={hasAttempted}
      />
    </>
  );
};

export default StandaloneQuizPage;

